import type { ExamplePhoto } from './types';

export const examplePhotos: ExamplePhoto[] = [
  // Original set
  {
    url: "https://preview.redd.it/hiring-ai-artist-hyper-realistic-human-images-v0-njvnx7w1ykjc1.png?width=768&format=png&auto=webp&s=cd2539150174a752ccbd19e2620b85eee59f084d",
    prompt: "Professional headshot, natural lighting, confident pose, business attire",
    style: "Modern",
    cameraAngle: "Three-Quarter",
    photoCount: 5,
    cameraType: "Canon EOS R5"
  },
  {
    url: "https://preview.redd.it/realistic-ordinary-woman-which-image-could-fool-you-v0-vx63py4h2dzb1.png?width=1080&crop=smart&auto=webp&s=6fa0dd213ca17b03a51fe14b50213a1cb46b78b6",
    prompt: "Natural portrait, soft lighting, genuine smile, casual elegance",
    style: "Natural Light",
    cameraAngle: "Front Face",
    photoCount: 5,
    cameraType: "Sony A7III"
  },
  {
    url: "https://i.redd.it/portraits-of-average-looking-humans-v0-8zbbxzwawtic1.jpg?width=1024&format=pjpg&auto=webp&s=8a27e2a4e699a1bd3197f46992b776165330d9ed",
    prompt: "Candid portrait, environmental setting, authentic expression",
    style: "Documentary",
    cameraAngle: "Three-Quarter",
    photoCount: 5,
    cameraType: "Fujifilm X-T4"
  },
  {
    url: "https://preview.redd.it/are-these-real-or-ai-v0-yiuwoc3ewr2c1.png?width=640&crop=smart&auto=webp&s=cedbcc3c52966b83bba007275d9303cbcab5eae1",
    prompt: "Professional portrait, studio lighting, polished look",
    style: "Studio",
    cameraAngle: "Close-Up",
    photoCount: 5,
    cameraType: "Phase One IQ4"
  },
  // New set
  {
    url: "https://photoai.com/cdn-cgi/image/format=auto,fit=cover,width=512,height=768,quality=85/https://r2-us-west.photoai.com/1725062639-20f27f81d17333bef9e106a83d6303c5-1.png",
    prompt: "Professional portrait, natural lighting, confident pose, business casual attire",
    style: "Modern",
    cameraAngle: "Three-Quarter",
    photoCount: 5,
    cameraType: "Canon EOS R5"
  },
  {
    url: "https://photoai.com/cdn-cgi/image/format=auto,fit=cover,width=512,height=768,quality=85/https://r2-us-west.photoai.com/1725049228-59e5679be5ad1ee0f05c529c09f2f50d-1.png",
    prompt: "Executive portrait, modern office setting, leadership presence",
    style: "Corporate",
    cameraAngle: "Three-Quarter",
    photoCount: 5,
    cameraType: "Sony A1"
  },
  {
    url: "https://photoai.com/cdn-cgi/image/format=auto,fit=cover,width=512,height=768,quality=85/https://r2-us-west.photoai.com/1725213116-41c444a0e73f71f832ec5abcd4605fb5-4.png",
    prompt: "Urban lifestyle portrait, casual elegance, city background",
    style: "Street",
    cameraAngle: "Full Body",
    photoCount: 5,
    cameraType: "Leica Q2"
  },
  {
    url: "https://photoai.com/cdn-cgi/image/format=auto,fit=cover,width=512,height=768,quality=85/https://r2-us-west.photoai.com/1725084854-3f194719c09f49b85f9035e29d624f3b-1.png",
    prompt: "Dating profile photo, warm smile, relaxed pose, approachable vibe",
    style: "Natural Light",
    cameraAngle: "Three-Quarter",
    photoCount: 5,
    cameraType: "Canon EOS R6"
  },
  {
    url: "https://photoai.com/cdn-cgi/image/format=auto,fit=cover,width=512,height=768,quality=85/https://r2-us-west.photoai.com/1725085022-bac9b4cd97ff738321251ce2e7419054-1.png",
    prompt: "Modern professional portrait, creative workspace, casual professional style",
    style: "Contemporary",
    cameraAngle: "Medium Shot",
    photoCount: 5,
    cameraType: "Sony A7III"
  },
  {
    url: "https://photoai.com/cdn-cgi/image/format=auto,fit=cover,width=512,height=768,quality=85/https://r2-us-west.photoai.com/1725212989-60bc6908b092d98ffad2390a63a3d9b2-4.png",
    prompt: "Lifestyle portrait, outdoor setting, natural light, genuine expression",
    style: "Lifestyle",
    cameraAngle: "Three-Quarter",
    photoCount: 5,
    cameraType: "Fujifilm X-T4"
  },
  {
    url: "https://photoai.com/cdn-cgi/image/format=auto,fit=cover,width=512,height=768,quality=85/https://r2-us-west.photoai.com/1725063585-e2a07f2cf92fa96ed34ed8d80b6262b7-1.png",
    prompt: "Contemporary portrait, minimalist background, sophisticated casual look",
    style: "Minimalist",
    cameraAngle: "Close-Up",
    photoCount: 5,
    cameraType: "Hasselblad X2D"
  },
  {
    url: "https://photoai.com/cdn-cgi/image/format=auto,fit=cover,width=512,height=768,quality=85/https://r2-us-west.photoai.com/1725080987-f32d41c348a34ca7f458f305c3500be2-1.png",
    prompt: "Professional headshot, studio lighting, confident smile, business attire",
    style: "Studio",
    cameraAngle: "Front Face",
    photoCount: 5,
    cameraType: "Phase One IQ4"
  },
  {
    url: "https://photoai.com/cdn-cgi/image/format=auto,fit=cover,width=512,height=768,quality=85/https://r2-us-west.photoai.com/1725059317-ed81dabd4b6219473f659e0940a30f37-1.png",
    prompt: "Casual business portrait, modern office, approachable professional look",
    style: "Business Casual",
    cameraAngle: "Three-Quarter",
    photoCount: 5,
    cameraType: "Nikon Z6"
  },
  {
    url: "https://photoai.com/cdn-cgi/image/format=auto,fit=cover,width=512,height=768,quality=85/https://r2-us-west.photoai.com/1725084370-4c172cfee30632573af768b86b7477c7-1.png",
    prompt: "Executive style portrait, premium setting, leadership presence",
    style: "Premium",
    cameraAngle: "Three-Quarter",
    photoCount: 5,
    cameraType: "Canon EOS R5"
  },
  {
    url: "https://photoai.com/cdn-cgi/image/format=auto,fit=cover,width=512,height=768,quality=85/https://r2-us-west.photoai.com/1725037177-90364f0fc033bff790331b917e6c83fd-1.png",
    prompt: "Lifestyle portrait, natural environment, casual professional",
    style: "Natural",
    cameraAngle: "Medium Shot",
    photoCount: 5,
    cameraType: "Sony A7IV"
  },
  {
    url: "https://photoai.com/cdn-cgi/image/format=auto,fit=cover,width=512,height=768,quality=85/https://r2-us-west.photoai.com/1726223738-432ce73ddf6df05a8c15058ba9d3aa2f-3.png",
    prompt: "Contemporary portrait, minimalist setting, sophisticated style",
    style: "Modern",
    cameraAngle: "Three-Quarter",
    photoCount: 5,
    cameraType: "Leica SL2"
  },
  {
    url: "https://photoai.com/cdn-cgi/image/format=auto,fit=cover,width=512,height=768,quality=85/https://r2-us-west.photoai.com/1726197487-2024252e2d1d4f7700839208b78b0311-4.png",
    prompt: "Professional headshot, premium lighting, executive presence",
    style: "Executive",
    cameraAngle: "Close-Up",
    photoCount: 5,
    cameraType: "Hasselblad X2D"
  },
  {
    url: "https://photoai.com/cdn-cgi/image/format=auto,fit=cover,width=512,height=768,quality=85/https://r2-us-west.photoai.com/1725042606-ee76e84a7dffb2f59031752651677493-1.png",
    prompt: "Urban professional portrait, city backdrop, modern business style",
    style: "Urban",
    cameraAngle: "Full Body",
    photoCount: 5,
    cameraType: "Sony A1"
  },
  {
    url: "https://photoai.com/cdn-cgi/image/format=auto,fit=cover,width=512,height=768,quality=85/https://r2-us-west.photoai.com/1726234309-ce6ed0816a56fdae2d80bfae69e944d7-4.png",
    prompt: "Creative portrait, artistic composition, expressive lighting",
    style: "Artistic",
    cameraAngle: "Dutch Angle",
    photoCount: 5,
    cameraType: "Leica M11"
  },
  {
    url: "https://photoai.com/cdn-cgi/image/format=auto,fit=cover,width=512,height=768,quality=85/https://r2-us-west.photoai.com/1726195700-e1b170f5774a7205ce12febb8adb3088-3.png",
    prompt: "Professional lifestyle portrait, natural environment, polished look",
    style: "Professional",
    cameraAngle: "Three-Quarter",
    photoCount: 5,
    cameraType: "Canon EOS R5"
  }
];